import React, { useState, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '@/App';
import { toast } from 'sonner';
import { Shield } from 'lucide-react';

const VerifyOTP = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useContext(AuthContext);
  const email = location.state?.email || '';
  const [otpCode, setOtpCode] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/verify-otp`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, otp_code: otpCode })
      });

      const data = await response.json();
      if (response.ok) {
        login(data.token, data.user);
        toast.success('Account verified successfully!');
        navigate('/dashboard');
      } else {
        toast.error(data.detail || 'Verification failed');
      }
    } catch (error) {
      toast.error('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#09090B] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-3 mb-4">
            <img src="/logo.png" alt="ZN Networks" className="h-12 w-auto" />
            <h1 className="text-3xl font-bold text-white" style={{ fontFamily: 'Sora' }}>Networks</h1>
          </div>
          <p className="text-white/60" style={{ fontFamily: 'Manrope' }}>Verify your account</p>
        </div>

        {/* Form Card */}
        <div className="card-glass p-8" data-testid="verify-otp-form">
          <div className="text-center mb-6">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-[#FFD60A]/10 border border-[#FFD60A]/30 mb-4">
              <Shield className="w-8 h-8 text-[#FFD60A]" />
            </div>
            <p className="text-white/80 text-sm" style={{ fontFamily: 'Manrope' }}>
              Enter the OTP code sent to <span className="text-[#FFD60A] font-semibold">{email}</span>
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-white/80 text-sm mb-2" style={{ fontFamily: 'Manrope' }}>
                OTP Code
              </label>
              <input
                type="text"
                required
                className="input-base w-full text-center text-2xl tracking-widest font-mono"
                value={otpCode}
                onChange={(e) => setOtpCode(e.target.value)}
                placeholder="000000"
                maxLength="6"
                data-testid="otp-input"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="btn-primary w-full"
              data-testid="verify-submit-btn"
            >
              {loading ? 'Verifying...' : 'Verify Account'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default VerifyOTP;